import gql from 'graphql-tag'


export const AllInboxesQuery = gql`query allInboxes($first: Int, $after: String, $name: String, $isArchived: Boolean){
    allInboxes(first: $first, after: $after, name: $name, isArchived: $isArchived){
        edges {
        node {
            id
            name
        }
        }
    }
}`


export const MyInboxesQuery = gql`query myInboxes($first: Int, $after: String, $name: String, $isArchived: Boolean){
    myInboxes(first: $first, after: $after, name: $name, isArchived: $isArchived){
        edges {
        node {
            id
            name
        }
        }
    }
}`


// Fragments
export const MESSAGE_FRAGMENT = gql`
  fragment MessageFields on MessageNode {
    id
    body
    isInbound
    sender
    recipient
    status
    externalId
    dateAdded
    channel {
      id
      channelType
      sendAs
    }
  }
`;

export const CONVERSATION_FRAGMENT = gql`
  fragment ConversationFields on ConversationNode {
    id
    status
    subject
    lastMessageAt
    tagsList
    contactName
    contactPhone
    contactEmail
    isReadByAssignedAgent
    driver {
      id
      name
      branch { id name }
    }
    channel {
      id
      name
      channelType
      sendAs
      inbox {
        id
        name
      }
    }
    inboxes {
      edges {
        node {
          id
          name
        }
      }
    }
    subscribers {
      edges {
        node {
          id
          username
          firstName
          lastName
          email
        }
      }
    }
    assignedTo {
      id
      username
      firstName
      lastName
    }
    threads {
      edges {
        node { id subject summary dateAdded endedAt tags }
      }
    }
    dateAdded
    dateModified
  }
`;

// Queries
export const GET_MY_CONVERSATIONS = gql`
  query GetMyConversations($status: String, $inboxId: ID, $first: Int, $after: String) {
    myConversations(status: $status, inboxes: $inboxId, first: $first, after: $after) {
      edges {
        node {
          ...ConversationFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const ASSIGNED_UNREAD_COUNT_QUERY = gql`
  query AssignedUnreadCount {
    assignedUnreadConversationCount
  }
`;

export const ALL_CONVERSATIONS = gql`
  query AllConversations($status: MessagingConversationStatusChoices, $driver: ID, $first: Int, $last: Int, $after: String, $before: String, $assignedTo: ID) {
    allConversations(status: $status, driver: $driver, first: $first, last: $last, after: $after, before: $before, assignedTo: $assignedTo) {
      edges {
        node {
          ...ConversationFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const GET_CONVERSATION = gql`
  query GetConversation($id: ID!) {
    conversation(id: $id) {
      ...ConversationFields
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const GET_MESSAGES = gql`
  query GetMessages($conversationId: ID!, $first: Int, $after: String) {
    allMessages(conversation: $conversationId, first: $first, after: $after) {
      edges {
        node {
          ...MessageFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${MESSAGE_FRAGMENT}
`;

export const GET_MY_INBOXES = gql`
  query GetMyInboxes {
    myInboxes {
      id
      name
      isArchived
    }
  }
`;

export const GET_INBOX_MEMBERS = gql`
  query GetInboxMembers($inboxIds: [ID!], $first: Int, $searchTerm: String) {
    inboxAccessUsers(inboxIds: $inboxIds, first: $first, searchTerm: $searchTerm) {
      role
      canBeAssigned
      user {
        id
        username
        email
        firstName
        lastName
      }
    }
  }
`;

export const GET_INBOX_CHANNELS = gql`
  query GetInboxChannels($inboxId: ID!, $first: Int) {
    allChannels(inbox: $inboxId, isArchived: false, first: $first) {
      edges {
        node {
          id
          name
          channelType
          sendAs
          isArchived
        }
      }
    }
  }
`;

export const GET_ALL_CHANNELS = gql`
  query GetAllChannels($first: Int) {
    allChannels(isArchived: false, first: $first) {
      edges {
        node {
          id
          name
          channelType
          sendAs
        }
      }
    }
  }
`;

export const GET_MESSAGE_TEMPLATES = gql`
  query GetMessageTemplates($first: Int) {
    allMessageTemplates(isActive: true, first: $first) {
      edges {
        node {
          id
          title
          content
          contentHtml
          shortcut
          isActive
        }
      }
    }
  }
`;

export const GET_ROUTING_RULES = gql`
  query GetRoutingRules($first: Int) {
    allRoutingRules(isActive: true, first: $first) {
      edges {
        node {
          id
          name
          priority
          conditions
          actionType
          actionTargetInbox {
            id
            name
          }
          actionTargetUser {
            id
            username
          }
          actionTag
          isActive
        }
      }
    }
  }
`;

export const GET_STARRED_CONVERSATIONS = gql`
  query GetStarredConversations {
    myStarredConversations {
      ...ConversationFields
    }
  }
  ${CONVERSATION_FRAGMENT}
`;

export const GET_DRIVER_CONTEXT = gql`
  query GetDriverContext($id: ID!) {
    driver(id: $id) {
      firstName
      lastName
      name
      email
      phone
      currentAgreement {
        startDate
        endDate
        baseCharge
        deposit
        car {
          year
          color
          vin
          dmvPlate
          carModel {
            make
            name
          }
        }
      }
    }
  }
`;

export const MESSAGE_ATTACHMENTS = gql`
  query MessageAttachments($ids: [ID]) {
    allMessageAttachments(ids: $ids) {
      edges {
        node {
          id
          url
        }
      }
    }
  }
`;
